import React, { useEffect, useRef, useState } from "react";
import "./ViewMeassageOffCanvas.css";
import { Form, Offcanvas } from "react-bootstrap";
import Black_Btn from "../../Common_Btn/Black_Btn/Black_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { createOrderMessage, getOrderMessage } from "../../../../features/order/orderSlice";

const ViewMeassageOffCanvas = (props) => {
  const {
    register,
    handleSubmit,
    setValue,reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  // Function to trigger file selection
  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  // Function to handle file selection
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    setValue("files", files); // Store files in React Hook Form
  };


  // Function to handle form submission
  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("order_detail_id", props.order.id);
    formData.append("message", data.message);
    // selectedFiles.forEach((file) => {
    //   formData.append("files", file);
    // });
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("file", selectedFiles[i]);
    }

    const res = await dispatch(createOrderMessage(formData));
    reset();
    await dispatch(getOrderMessage());
    if (res.meta?.requestStatus === "fulfilled") {
   
    }
  };

  // Fetch order messages
  const order = useSelector((state) => state.order.orderMessage);
  useEffect(() => {
    dispatch(getOrderMessage());
  }, [dispatch]);

  return (
    <section>
      <Offcanvas {...props} className="ViewMeassageOffCanvas" placement="top">
        <Offcanvas.Body>
          <div className="offcanvas_container">
            <div className="top_part">
              <div className="profile_holder">
                <div className="img_holder">
                  <img src="\assets\Images\AccountSetting\img.png" alt="User" />
                </div>
                <div className="text_holder">
                  <p className="text">Sneha Tilekar</p>
                </div>
              </div>

              {/* File Upload Section */}
              <div className="add_files_holder" onClick={handleFileClick}>
                <input
                  type="file"
                  multiple
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <div className="icon_holder">
                  <FontAwesomeIcon icon={faPlus} className="icon" />
                </div>
                <div>
                  <p className="add_file_text">Add Files</p>
                </div>
              </div>
            </div>

            {/* Display Selected Files */}
            {selectedFiles.length > 0 && (
              <div className="selected-files">
                <p>Selected Files:</p>
                <ul>
                  {selectedFiles.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              </div>
            )}

            <div className="form_div">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    as="textarea"
                    name="message"
                    placeholder="Post your message here."
                    {...register("message", {
                      required: "Message is required",
                    })}
                  />
                  {errors?.message && (
                    <sup className="text-danger">{errors?.message?.message}</sup>
                  )}
                </Form.Group>

                <input
                  type="hidden"
                  {...register("files")} // Register files in React Hook Form
                />

                <div className="footer_holder">
                  <div className="btn_holder">
                    <div className="cancel_btn" onClick={() => props?.onHide()}>
                      <Black_Btn btnText={"Cancel"} />
                    </div>
                    <button type="submit">
                      <Black_Btn btnText={"Send"} />
                    </button>
                  </div>
                  <div className="text_content">
                    <p className="text">Get reply within 24 hours</p>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
};

export default ViewMeassageOffCanvas;
